<template>
  <div class="min-h-screen bg-gray-50 font-sans text-gray-900">
    
    <!-- Mobile Backdrop Overlay -->
    <div
      v-if="isMobileOpen"
      @click="isMobileOpen = false"
      class="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm md:hidden transition-opacity"
    ></div>

    <!-- Sidebar Component (Fixed 100% Full Height Left Navigation) -->
    <Sidebar
      :is-mobile-open="isMobileOpen"
      @close-mobile="isMobileOpen = false"
    />

    <!-- Main Content Area (Offset by 256px / w-64 sidebar on desktop) -->
    <div class="md:pl-64 flex flex-col min-h-screen">
      
      <!-- Top Navigation Header -->
      <div class="sticky top-0 z-30">
        <TopNav @toggle-sidebar="isMobileOpen = !isMobileOpen" />
      </div>

      <!-- Main Content Area -->
      <main class="flex-1">
        <slot />
      </main>
      
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import Sidebar from './Sidebar.vue';
import TopNav from './TopNav.vue';

const isMobileOpen = ref(false);
const route = useRoute();

// Auto close mobile drawer on page change
watch(() => route.fullPath, () => {
  isMobileOpen.value = false;
});
</script>
